var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:color-wheel",
    clipPath: "url(#clip0_39103_48434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 1.83301C4.59675 1.83301 1.83594 4.59382 1.83594 7.99967C1.83594 11.4055 4.59675 14.1663 8.0026 14.1663C11.4085 14.1663 14.1693 11.4055 14.1693 7.99967C14.1693 4.59382 11.4085 1.83301 8.0026 1.83301ZM0.835938 7.99967C0.835938 4.04153 4.04446 0.833008 8.0026 0.833008C11.9607 0.833008 15.1693 4.04153 15.1693 7.99967C15.1693 11.9578 11.9607 15.1663 8.0026 15.1663C4.04446 15.1663 0.835938 11.9578 0.835938 7.99967Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 0.833008C8.27875 0.833008 8.5026 1.05687 8.5026 1.33301V4.87272C8.99286 4.95111 9.45805 5.14379 9.86014 5.43503L12.363 2.93212C12.5583 2.73686 12.8749 2.73686 13.0702 2.93212C13.2654 3.12738 13.2654 3.44397 13.0702 3.63923L10.5673 6.14213C10.8585 6.54423 11.0512 7.00942 11.1296 7.49967H14.6693C14.9454 7.49967 15.1693 7.72353 15.1693 7.99967C15.1693 8.27582 14.9454 8.49967 14.6693 8.49967H11.1296C11.0512 8.98993 10.8585 9.45512 10.5672 9.85721L13.0702 12.3601C13.2654 12.5554 13.2654 12.872 13.0702 13.0672C12.8749 13.2625 12.5583 13.2625 12.363 13.0672L9.86014 10.5643C9.45805 10.8556 8.99286 11.0482 8.5026 11.1266V14.6663C8.5026 14.9425 8.27875 15.1663 8.0026 15.1663C7.72646 15.1663 7.5026 14.9425 7.5026 14.6663V11.1266C7.01235 11.0482 6.54716 10.8556 6.14506 10.5643L3.64216 13.0672C3.44689 13.2625 3.13031 13.2625 2.93505 13.0672C2.73979 12.872 2.73979 12.5554 2.93505 12.3601L5.43796 9.85721C5.14672 9.45512 4.95404 8.98993 4.87565 8.49967H1.33594C1.0598 8.49967 0.835938 8.27582 0.835938 7.99967C0.835938 7.72353 1.0598 7.49967 1.33594 7.49967H4.87565C4.95408 7.00914 5.14694 6.5437 5.43845 6.14145L2.93513 3.63931C2.73983 3.44409 2.73975 3.12751 2.93497 2.9322C3.13018 2.7369 3.44677 2.73682 3.64207 2.93204L6.14575 5.43453C6.54769 5.14357 7.01262 4.95106 7.5026 4.87272V1.33301C7.5026 1.05687 7.72646 0.833008 8.0026 0.833008ZM8.0026 5.83301C7.42797 5.83301 6.87687 6.06128 6.47054 6.46761C6.06421 6.87394 5.83594 7.42504 5.83594 7.99967C5.83594 8.57431 6.06421 9.12541 6.47054 9.53174C6.87687 9.93807 7.42797 10.1663 8.0026 10.1663C8.57724 10.1663 9.12834 9.93807 9.53467 9.53174C9.941 9.12541 10.1693 8.57431 10.1693 7.99967C10.1693 7.42504 9.941 6.87394 9.53467 6.46761C9.12834 6.06128 8.57724 5.83301 8.0026 5.83301Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 102",
    d: "M9.33073 1.33333C9.33073 2.06971 8.73378 2.66667 7.9974 2.66667C7.26102 2.66667 6.66406 2.06971 6.66406 1.33333C6.66406 0.596954 7.26102 0 7.9974 0C8.73378 0 9.33073 0.596954 9.33073 1.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 103",
    d: "M9.33073 14.6663C9.33073 15.4027 8.73378 15.9997 7.9974 15.9997C7.26102 15.9997 6.66406 15.4027 6.66406 14.6663C6.66406 13.93 7.26102 13.333 7.9974 13.333C8.73378 13.333 9.33073 13.93 9.33073 14.6663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 104",
    d: "M14.6667 9.33366C13.9303 9.33366 13.3333 8.73671 13.3333 8.00033C13.3333 7.26395 13.9303 6.66699 14.6667 6.66699C15.403 6.66699 16 7.26395 16 8.00033C16 8.73671 15.403 9.33366 14.6667 9.33366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 105",
    d: "M1.33073 9.33366C0.594349 9.33366 -0.00260434 8.73671 -0.0026043 8.00033C-0.00260427 7.26395 0.594349 6.66699 1.33073 6.66699C2.06711 6.66699 2.66406 7.26395 2.66406 8.00033C2.66406 8.73671 2.06711 9.33366 1.33073 9.33366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 106",
    d: "M13.6537 4.22882C13.133 4.74952 12.2888 4.74952 11.7681 4.22882C11.2474 3.70812 11.2474 2.8639 11.7681 2.3432C12.2888 1.8225 13.133 1.8225 13.6537 2.3432C14.1744 2.8639 14.1744 3.70812 13.6537 4.22882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 107",
    d: "M4.23187 13.6566C3.71117 14.1773 2.86695 14.1773 2.34625 13.6566C1.82555 13.1359 1.82555 12.2916 2.34625 11.7709C2.86695 11.2502 3.71117 11.2502 4.23187 11.7709C4.75257 12.2916 4.75257 13.1359 4.23187 13.6566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 108",
    d: "M11.7731 13.6567C11.2524 13.136 11.2524 12.2918 11.7731 11.7711C12.2938 11.2504 13.1381 11.2504 13.6588 11.7711C14.1795 12.2918 14.1795 13.136 13.6588 13.6567C13.1381 14.1774 12.2938 14.1774 11.7731 13.6567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 109",
    d: "M2.34345 4.22894C1.82275 3.70824 1.82275 2.86402 2.34345 2.34332C2.86415 1.82262 3.70837 1.82262 4.22907 2.34332C4.74977 2.86402 4.74977 3.70824 4.22907 4.22894C3.70837 4.74964 2.86415 4.74964 2.34345 4.22894Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39103_48434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.bcc3338b317d6b5a69a92bfba1fd2f01.svg";
export { ForwardRef as ReactComponent };